import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { ProductInformationViewModel } from 'autogen/swagger/all';
import { NoticeHazardLabel, SeeHazardLabel } from 'autogen/translation-keys/trans-website-product-hazardlabel';
import InlineButton from 'components/generic/InlineButton';
import { Typography } from 'components/generic/typography';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    align-items: start;
`;
export default function HazardLabel({
    model: hazarlabelUrls
}: {
    model: ProductInformationViewModel['hazarlabelUrls'];
}) {
    const { t } = useTranslation();

    return (
        <Container>
            <Typography.Body as="span" size="S">
                {t(NoticeHazardLabel)} -{' '}
            </Typography.Body>
            {hazarlabelUrls.map((hazardLabelUrl) => (
                <InlineButton
                    as="a"
                    size="M"
                    key={hazardLabelUrl}
                    href={hazardLabelUrl}
                    target="_blank"
                    rel="noreferrer"
                >
                    {t(SeeHazardLabel)}
                </InlineButton>
            ))}
        </Container>
    );
}
